$(document).on('click','.subscribeEventPedirNif .socio.btn',function(){
    if (!$(".event-form-subscribe-id_mst_socios").length){
        $("#event-form-subscribe").append('<input type="hidden" class="event-form-subscribe-id_mst_socios" name="id_mst_socios" value="'+$(this).data('id_mst_socios')+'"/>');
    }else{
        $(".event-form-subscribe-id_mst_socios").val($(this).data('id_mst_socios'));
    }
    $("#modal_c").modal('toggle',function(){
        $("#modal_c").remove();
    });
    submit_form($("#event-form-subscribe"));
    // $("#event-form-subscribe").find('.btn-warning').click();
});

$(document).on('click','#event-form-subscribe .btn-warning',function(){
   $(".event-form-subscribe-id_mst_socios").remove();
});



$(document).on('click','.unsubscribeEventPedirNif .socio.btn',function(){
    var form = $("input[value='unsubscribe_event']").closest('form');
    if (!$(".event-form-id_mst_socios").length){
        $(form).append('<input type="hidden" class="event-form-id_mst_socios" name="id_mst_socios" value="'+$(this).data('id_mst_socios')+'"/>');
    }else{
        $(".event-form-id_mst_socios").val($(this).data('id_mst_socios'));
    }
    $("#modal_c").modal('toggle',function(){
        $("#modal_c").remove();
    });
    $(form).find('.btn-danger').click();
    setTimeout(function(){
        $(".event-form-id_mst_socios").remove();
    }, 1000);
});

$(document).on('click','.addEventPedirNif .socio.btn',function(){
    var form = $("input[value='add_event']").closest('form');
    if (!$(".add-event-form-id_mst_socios").length){
        $(form).append('<input type="hidden" class="add-event-form-id_mst_socios" name="id_mst_socios" value="'+$(this).data('id_mst_socios')+'"/>');
    }else{
        $(".add-event-form-id_mst_socios").val($(this).data('id_mst_socios'));
    }
    $("#modal_c").modal('toggle',function(){
        $("#modal_c").remove();
    });

    $(form).find('#add-event').click();
});


